const PRODUCTION_DEFAULT = 'www.dayaxe.com';

export const getCanonicalHost = () => {
  if (process.env.PUBLIC_SITE_URL) {
    return process.env.PUBLIC_SITE_URL;
  }
  if (typeof window !== 'undefined') {
    return window.location.host;
  }
  return PRODUCTION_DEFAULT;
};
